import ReactDOM from 'react-dom/client';
import { withProviders } from './providers';
import { Router } from './context/Router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLDivElement
);

const Root = withProviders(Router);
root.render(<Root />);
